import { render, staticRenderFns } from "./MyCoursesTables.vue?vue&type=template&id=cc479734&"
import script from "./MyCoursesTables.vue?vue&type=script&lang=js&"
export * from "./MyCoursesTables.vue?vue&type=script&lang=js&"
import style0 from "./MyCoursesTables.vue?vue&type=style&index=0&id=cc479734&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports